import { jsPDF } from "jspdf";

export default function genPDFEPSONLX({
  datosfactura,
  detallefactura,
  isCredito,
  TextoNumber,
  sum1,
  sum2,
  impx,
  impy
}) {
  const doc = new jsPDF({
    unit: "mm",
    orientation: "landscape",
    format: [310, 210], // A4 en mm
  });

  // ✅ Función para separar miles
  const formatMiles = (num) => {
    if (num === undefined || num === null || num === "") return "";
    return Number(num).toLocaleString("es-PY");
  };

  // ✅ Valores por defecto
  datosfactura.direccion = datosfactura.direccion || "";
  datosfactura.telefono = datosfactura.telefono || "";
  datosfactura.iva5 = datosfactura.iva5 ?? datosfactura.gravado05;
  datosfactura.iva10 = datosfactura.iva10 ?? datosfactura.gravado10;
  datosfactura.totalmonto = datosfactura.totalmonto ?? datosfactura.totalFactura;
  datosfactura.ivatotal =
    datosfactura.ivatotal ??
    Number(datosfactura.gravado05 + datosfactura.gravado10);
  datosfactura.Subtotal5 = datosfactura.Subtotal5 ?? sum1;
  datosfactura.Subtotal10 = datosfactura.Subtotal10 ?? sum2;
  datosfactura.fechafactura =
    datosfactura.fechafactura ?? new Date().toLocaleDateString();

  const writePage = (offsetX = 0, offsetY = 0) => {
    let gapRow = 12;
    let isContado = !isCredito;
    let casillaX = offsetX + 121.5 + (isContado ? 12 : 23);

    doc.setFont(undefined, "normal");
    doc.setFontSize(7.5);

    doc.text("X", casillaX, offsetY + 32);
    doc.text(datosfactura.fechafactura, offsetX + 35, offsetY + 33);
    doc.text(datosfactura.razonsocial, offsetX + 40, offsetY + 36.5);
    doc.text(datosfactura.ruc, offsetX + 33, offsetY + 40.5);
    doc.setFontSize(6.0);
    doc.text(datosfactura.direccion, offsetX + 72, offsetY + 40.5);
    doc.text(datosfactura.telefono, offsetX + 128, offsetY + 40.5);

    // ✅ Ítems
    let currentY = offsetY + 53.5;
    for (const obj of detallefactura) {
      const usedHeight = addRow(obj, offsetX + 3, currentY);
      currentY += usedHeight + 1.5; // pequeño espacio extra entre ítems
    }

    // ✅ Subtotales y totales con separador de miles
    doc.text(formatMiles(datosfactura.Subtotal5), offsetX + 120, offsetY + 195);
    doc.text(formatMiles(datosfactura.Subtotal10), offsetX + 132, offsetY + 195);
    doc.setFontSize(8.0);
    doc.text(TextoNumber, offsetX + 42, offsetY + 199, { maxWidth: 180 / 2.834645 });
     doc.setFontSize(10);
    doc.text(formatMiles(datosfactura.totalmonto), offsetX + 132, offsetY + 201);
    doc.text(formatMiles(datosfactura.iva5), offsetX + 54.5, offsetY + 206);
    doc.text(formatMiles(datosfactura.iva10), offsetX + 83.5, offsetY + 206);
    doc.text(formatMiles(datosfactura.ivatotal), offsetX + 118.5, offsetY + 206);
  };

  const addRow = (data, x = 0, y) => {
    doc.setFontSize(10);
    const lineHeight = 4; // altura de línea
    const maxWidth = 40;  // ancho de columna descripción
    const splitDescripcion = doc.splitTextToSize(data.producto, maxWidth);

    // 🔹 Cantidad y código
    doc.setFontSize(8);
    doc.text(String(data.cantidad), x + 13, y);
    doc.text(String(data.artcod), x + 22, y);

    // 🔹 Descripción multilínea
    doc.text(splitDescripcion, x + 35, y);

    // 🔹 Precios solo en la PRIMERA línea
    const yValores = y; // mantener alineado arriba, no dentro del bloque
    doc.text(formatMiles(data.precio), x + 82, yValores);
    doc.text(formatMiles(data.exenta), x + 98, yValores);
    doc.text(formatMiles(data.cinco), x + 112, yValores);
    doc.text(formatMiles(data.diez), x + 129, yValores);

    // 🔹 Retornar la altura total que ocupa la fila
    return splitDescripcion.length * lineHeight;
  };


  writePage(impx + 2, impy);
  writePage(impx + 158, impy);

  doc.autoPrint();
  doc.output("dataurlnewwindow");
}